import { render } from "./CardVehicleSkeleton.vue?vue&type=template&id=2267ccc6&scoped=true"
const script = {}

import "./CardVehicleSkeleton.vue?vue&type=style&index=0&id=2267ccc6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2267ccc6"]])

export default __exports__